import { ApolloClient, gql } from '@apollo/client';

const partnerCache = new Map<string, Promise<any>>();

export async function getB2bPartnerByName(
  partnerName: string,
  strapiUrl: string,
  strapiToken: string,
  enrollmentClient: ApolloClient<any>
): Promise<Partner | undefined> {
  const url = `${strapiUrl}/api/partners?populate=*&filters[name][$eqi]=${partnerName}`;

  if (!partnerCache.has(partnerName)) {
    partnerCache.set(
      partnerName,
      fetch(url, {
        headers: {
          Authorization: 'Bearer ' + strapiToken,
        },
        cache: 'no-cache',
      })
        .then((res) => res.json())
        .then((res) => res.data[0])
        .then(async (res) => {
          if (res) {
            const item = res.attributes;

            const agentId = item?.agent?.data?.attributes.admin_id || null;
            let b2bMeetingUrl: string | undefined = undefined;

            if (item?.calendlyLinkOverride) {
              b2bMeetingUrl = item?.calendlyLinkOverride;
            } else if (agentId) {
              b2bMeetingUrl = await getAgentCalendlyUrl(
                agentId,
                enrollmentClient
              );
            }

            return {
              name: item?.name || '',
              logo: `${strapiUrl}${item?.logo?.data?.attributes.url}`,
              logoHeight: item?.logoHeight || 60,
              calendlyLinkOverride: item?.calendlyLinkOverride || '',
              color: item?.color || '',
              phoneNumber: item?.phoneNumber ?? '8889697667',
              metaImage: {
                url: item?.metaImage?.data?.attributes.url
                  ? `${strapiUrl}${item?.metaImage?.data?.attributes.url}`
                  : '',
                height: item?.metaImage?.data?.attributes.height || null,
                width: item?.metaImage?.data?.attributes.width || null,
              },
              agent: {
                name: item?.agent?.data?.attributes.name || null,
                id: agentId,
                b2bMeetingUrl:
                  b2bMeetingUrl ||
                  'https://calendly.com/coverright-advisors/medicare-consultation-partners',
              },
            };
          }
          return undefined;
        })
    );
  }
  return partnerCache.get(partnerName);
}

async function getAgentCalendlyUrl(
  id: string,
  enrollmentClient: ApolloClient<any>
): Promise<string | undefined> {
  return await enrollmentClient
    .query({
      query: gql`
    query agentById($id: UUID!) {
  agentById(id: $id) {
    b2bMeetingUrl
    email
    firstName
    id
    lastName
    picUrl
    phone
    enrollmentMeetingUrl
    planReviewUrl
    consultationUrl
  }
}
    `,
      variables: { id },
    })
    .then((data) => data.data?.agentById.b2bMeetingUrl || undefined);
}

export interface Partner {
  name: string;
  logo?: string;
  color?: string;
  phoneNumber: string;
  calendlyLinkOverride?: string;
  metaImage?: { width: number; height: number; url: string };
  agent: PartnerAgent;
  logoHeight: number;
}

export interface PartnerAgent {
  b2bMeetingUrl?: string | null;
  email: string;
  firstName: string;
  id: any;
  lastName: string;
  picUrl?: string | null;
  phone?: string | null;
  enrollmentMeetingUrl?: string | null;
  planReviewUrl?: string | null;
  consultationUrl?: string | null;
}
